import { render, staticRenderFns } from "./ChatHistoryFilter.vue?vue&type=template&id=204e51f6&lang=pug"
import script from "./ChatHistoryFilter.vue?vue&type=script&lang=js"
export * from "./ChatHistoryFilter.vue?vue&type=script&lang=js"
import style0 from "./ChatHistoryFilter.vue?vue&type=style&index=0&id=204e51f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports